<div class="notification-wrapper">
  @for (n of notifications; track trackById($index, n)) {
    <app-notification-inbox
      [data]="n.data"
      [fecha]="n.fecha"
      (closed)="removeNotification(n.id)">
    </app-notification-inbox>
  }
</div>